"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const browser_1 = __importDefault(require("@hyperdx/browser"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const components_1 = require("components");
const config_1 = require("config");
const consumer_applications_v1_api_1 = require("consumer-applications-v1-api");
const hooks_1 = require("hooks");
const utils_1 = require("utils");
const creditAppActions = __importStar(require("../../credit_application/actions"));
const actions_1 = require("../../credit_application/actions");
const actions = __importStar(require("../actions"));
const actions_2 = require("../actions");
const reducer_1 = require("../reducer");
const ApplicantShow_1 = __importDefault(require("./ApplicantShow"));
function ContinuedCreditApplication({ clearApplicant, creditApplication, practice, setPrequalification, setPersonalInfo, setPractice, setLenderReferenceId, clearApplicationEnvironment, applicationEnvironment, }) {
    const { search } = (0, react_router_dom_1.useLocation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useHistory)();
    const [getBlackboxData] = (0, hooks_1.useIovation)();
    const { locationId } = practice || {};
    const [prequalifyWithNextLender] = (0, consumer_applications_v1_api_1.usePostConsumerApplicationsV1PrequalificationsApplicationIdNextLenderMutation)();
    const { data: newCreditApplication, isFetching: isFetchingCreditApplication, } = (0, consumer_applications_v1_api_1.useGetConsumerApplicationsV1PrequalificationsNewQuery)({ locationId });
    const [patchApplicant] = (0, consumer_applications_v1_api_1.usePatchConsumerApplicationsV1CreditApplicationsApplicationIdMutation)();
    const { applicationId } = creditApplication;
    const handleSubmit = (formValues) => {
        browser_1.default.setGlobalAttributes({
            locationId: practice.locationId.toString() || '',
            creditApplicationId: creditApplication.applicationId?.toString() || '',
            lastName: formValues.lastName,
            firstName: formValues.firstName,
            email: formValues.email,
            phone: formValues.primaryPhone,
            form: 'cont-cred-app',
        });
        return patchApplicant({
            applicationId: applicationId ? applicationId : '',
            patchConsumerApplicationsV1CreditApplicationsApplicationId: formValues,
        }).then(() => {
            return prequalifyWithNextLender({
                applicationId: applicationId ? applicationId : '',
                postConsumerApplicationsV1PrequalificationsApplicationIdNextLender: {
                    iovationBlackBox: getBlackboxData().blackbox,
                },
            }).then((response) => {
                if ('data' in response) {
                    setPractice(practice);
                    setPersonalInfo(formValues);
                    setPrequalification(response.data);
                    setLenderReferenceId(response.data.lenderRequestReferenceId ?? '');
                    return response.data;
                }
            });
        });
    };
    const handleSubmitSuccess = (response) => {
        const nextStep = (0, utils_1.determinePrequalificationResponse)(response, 'no-modal');
        history.push(nextStep);
        return;
    };
    const handleSubmitFailure = (errors, dispatch, submitError) => {
        const apiErrorCode = submitError?.meta?.error?.response?.errorCode;
        if (apiErrorCode === 'new_application_required') {
            history.push((0, utils_1.makeQueryPath)(config_1.CREDIT_PORTAL_URL, { [config_1.QUERY_KEY.ERROR]: apiErrorCode }));
        }
        else {
            (0, utils_1.flashSubmitFailure)(errors, dispatch, submitError);
        }
    };
    (0, react_1.useEffect)(() => {
        if (newCreditApplication) {
            if (newCreditApplication) {
                dispatch((0, actions_2.setApplicationEnvironment)(newCreditApplication));
                dispatch((0, actions_1.setApplicationEnvironment)(newCreditApplication));
            }
        }
    }, [newCreditApplication]);
    (0, react_1.useEffect)(() => {
        return () => {
            clearApplicant();
            clearApplicationEnvironment();
        };
    }, []);
    if (((0, lodash_1.isNil)(creditApplication) && !isFetchingCreditApplication) || !practice) {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: {
                pathname: config_1.APPLICANTS_URL,
                search: search,
            } }));
    }
    if (!applicationEnvironment)
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true });
    return ((0, jsx_runtime_1.jsx)(ApplicantShow_1.default, { practice: practice, handleSubmit: handleSubmit, handleSubmitSuccess: handleSubmitSuccess, handleSubmitFailure: handleSubmitFailure, applicationEnvironment: applicationEnvironment }));
}
function mapStateToProps(state) {
    return {
        creditApplication: reducer_1.selectors.creditApplication(state),
        practice: reducer_1.selectors.practice(state),
        applicationEnvironment: reducer_1.selectors.applicationEnvironment(state),
    };
}
const mapDispatchToProps = {
    clearApplicant: actions.clearApplicant,
    setPrequalification: creditAppActions.setPrequalification,
    setPersonalInfo: creditAppActions.setPersonalInfo,
    setPractice: creditAppActions.setPractice,
    setLenderReferenceId: creditAppActions.setLenderReferenceId,
    clearApplicationEnvironment: actions.clearApplicationEnvironment,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(ContinuedCreditApplication);
